import React from 'react';
import './shareBar.scss';
import Icon from 'components/icon/icon';
import { useOptions } from 'hooks/useOptions.query';
import { useLocation, Location } from '@reach/router';

interface Props {
  text?: string;
}

const ShareBar: React.FC<Props> = (props) => {
  const options = useOptions();

  const { share } = options.wp.themeGeneralSettings.theme;

  const location = useLocation();
  const url = location.href;

  if (!url) {
    return null;
  }

  return (
    <div className="share-bar">
      <div className="share-bar__wrapper">
        <div className="share-bar__header">{props.text ?? 'Artikel teilen'}</div>
        <div className="share-bar__row">
          {/* MAIL */}
          <a className="share-bar-item" href={`mailto:?subject=${share.mailSubject}&body=${share.mailBody.replaceAll('%link%', url)}`}>
            <Icon icon="email" size="20" />
          </a>
          {/* LINKEDIN */}
          <a className="share-bar-item" href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} target="_blank">
            <Icon icon="linkedin" size="20" />
          </a>
          {/* TWITTER */}
          <a className="share-bar-item" href={`https://twitter.com/intent/tweet?text=${share.twitterText.replaceAll('%link%', url)}`} target="_blank">
            <Icon icon="twitter" size="20" />
          </a>
          {/* FACEBOOK */}
          <a className="share-bar-item" href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target="_blank">
            <Icon icon="facebook" size="20" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ShareBar;
